var formatName = function formatName(first, last) {
  return first.replace(/\W/g, '').toUpperCase() + last.replace(/\W/g, '').toUpperCase();
};

var format = function format(word) {
  return decodeURIComponent(word.replace(/\W/g, '').toUpperCase());
};

var formatYearMonth = function formatYearMonth(date) {
  return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2);
};

var formatDate = function formatDate(date) {
  return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
};

var formatDateTime = function formatDateTime(date) {
  return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + ' ' + date.getHours() + ':' + ('0' + date.getMinutes()).slice(-2);
};

var formatTime = function formatTime(date) {
  return date.getHours() + ':' + ('0' + date.getMinutes()).slice(-2);
};

var generateRange = function generateRange(date, days) {
  var start;
  var stop;

  if (date) {
    stop = new Date(date);
    start = new Date(date);
  } else {
    stop = new Date();
    start = new Date();
  }

  start.setDate(stop.getDate() - days);
  return [start, stop];
};

var toDate = function toDate(dateStr) {
  var parts = dateStr.split("-");
  return new Date(parts[0], parts[1] - 1, parts[2]);
};

var dateDiff = function dateDiff(first, second) {
  // Take the difference between the dates and divide by milliseconds per day.
  // Round to nearest whole number to deal with DST.
  return Math.round((second - first) / (1000 * 60 * 60 * 24));
};

var pause = function pause(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

var formatVersion = function formatVersion(version) {
  version = version + '';
  return 'V' + version.padStart(5, '0');
};

var getVersionInt = function getVersionInt(version) {
  try {
    return parseInt(version.substring(1));
  } catch (e) {
    console.error('Invalid version format: ' + version);
    return null;
  }
};

var utcStrToDate = function utcStrToDate(dateStr) {
  if (!dateStr) {
    return new Date();
  }

  var parts = dateStr.split(' ');
  var date = parts[0].split('-');
  var time = parts[1].split(':');
  var dateObj = new Date(date[0], date[1] - 1, date[2], time[0], time[1]);
  var offset = dateObj.getTimezoneOffset() / 60;
  var hours = dateObj.getHours();
  dateObj.setHours(hours - offset);
  return dateObj;
};

var formatBytes = function formatBytes(bytes) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (!+bytes) return '0 Bytes';
  var k = 1024;
  var dm = decimals < 0 ? 0 : decimals;
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return "".concat(parseFloat((bytes / Math.pow(k, i)).toFixed(dm)), " ").concat(sizes[i]);
};

module.exports = {
  format: format,
  formatDate: formatDate,
  formatDateTime: formatDateTime,
  formatName: formatName,
  generateRange: generateRange,
  toDate: toDate,
  formatYearMonth: formatYearMonth,
  dateDiff: dateDiff,
  pause: pause,
  formatVersion: formatVersion,
  getVersionInt: getVersionInt,
  utcStrToDate: utcStrToDate,
  formatTime: formatTime,
  formatBytes: formatBytes
};